import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MandatoryComponent } from 'src/app/view/mandatory/mandatory.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    MandatoryComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'',component:MandatoryComponent}
    ]),
  ]
})
export class MandatoryModule { }
